//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import InteractivePanel from "@/components/interactive_panel";
import Swiper from "swiper/swiper-bundle.esm";
import "swiper/swiper-bundle.css";
export default {
  name: "Broadcast",
  components: {
    "c-interactive-panel": InteractivePanel,
  },
  props: {
    notices: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  computed: {
    notice_cotent() {
      return this.notices.map((_) => _.notice).join("<br/><br/>");
    },
  },
  mounted() {
    setTimeout(() => {
      this.initBroadcast();
    }, 1000);
  },
  data() {
    return {
      notice_modal_show: !sessionStorage.isClose,
    };
  },
  methods: {
    CloseModal(state) {
      this.notice_modal_show = state;
      if (!state) {
        sessionStorage.isClose = true;
      }
    },
    initBroadcast() {
      // eslint-disable-next-line no-new
      new Swiper(".c-broadcast", {
        loop: true,
        direction: "vertical",
        autoplay: true,
      });
    },
  },
};
